import { useAppContext } from "../../../AppProvider";
import { useIndexEmailNotificationsContext } from "../providers/Index";

export const useListProps = () => {
  const { dictionary } = useAppContext();
  const { action, parentId } = useIndexEmailNotificationsContext();

  return {
    path: `/registry-service/email-notifications`,
    banner: {
      enabled: action !== "details",
    },
    pagination: { enabled: action !== "details" },
    title: action !== "details" && dictionary.registries.email,
    selectRowsEnabled: { enabled: false },
    sorting: [
      {
        orderBy: "desc",
        column: "creationDate",
        isDefault: true,
      },
    ],
    filters: {
      name: "emailNotifications",
      preserve: false,
      hidden: action === "details",
      list: [
        {
          fieldName: "recipient",
          label: dictionary.registries.receiver,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "externalReference",
          label: dictionary.references.external_reference,
          type: "text",
          primary: true,
          col: 3,
          value: action === "details" && parentId ? parentId : null,
        },
      ],
    },
  };
};
